import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../LangContext";
import "./Footer.css";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer className="app-footer" aria-label="Site footer">
      <div className="app-footer-links">
        <Link to="/imprint">{t.imprintTitle}</Link>
        <span className="app-footer-sep" aria-hidden="true"> · </span>
        <Link to="/privacy">{t.privacyTitle}</Link>
        <span className="app-footer-sep" aria-hidden="true"> · </span>
        <Link to="/terms">{t.termsTitle}</Link>
      </div>
    </footer>
  );
}
